import styled from '@emotion/styled';
import {Pagination} from "components";

import {Radio as RadioBase} from "@britishcouncil/react-extro-ui";

export const StyledPageContainer = styled.div`
  &&& {
    div[data-testid='page-container'] {
      padding: 0px;
      background-color: inherit;
    }
  }
`;

export const Header = styled.div`
  position: relative;
  margin-bottom: 50px;
  display: flex;
  justify-content: space-between;

  span {
    font-family: BCSansHeading, Arial, 'Helvetica Neue', Helvetica, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 53px;
    color: #23085a;
  }

  &::after {
    content: '';
    width: 58px;
    height: 0px;
    border: 3px solid #23085a;
    border-radius: 12px;
    left: 0px;
    bottom: -20px;
    position: absolute;
  }
`;

// export const SummaryTitle = styled.h4`
//   font-size: ${({ theme }) => theme.fontSize.desktop.h4};
// `;

export const ContentWrapper = styled.div`
  border-radius: 16px;
  padding: 20px;
  border: 2px solid #f4f4f4;

  &.archived-container {
    background: #f4f4f4;
  }

  .btn-disable {
    background: #c8c8c8 !important;
    border-color: #c8c8c8 !important;
    color: #54565a !important;
  }
`;

export const FiltersRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
`;

export const TabsContainer = styled.div`
  margin: 32px 0;

  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const EmptyStateInformation = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 550px;
  font-size: 22px;
  color: #000;
`;

export const EmptyResultInformation = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  color: #000;
`;

